import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { IResourceType } from "../../../@types/resource.type";
import { Resource } from "../Resource";
import { getResourceById } from "../../../services/api/resource/resourceService";
import { includeCustomFieldsfromApi } from "../adapters/resourceCustomFields";
import { useSyncActive } from "../../../utils/useSyncActive";

export const UpdateResource: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [openModalAvailability, setOpenModalAvailability] =
    useState<boolean>(true);
  const [resource, setResource] = useState({} as IResourceType);
  const { id } = useParams();
  const navigate = useNavigate();

  const isSyncActive = useSyncActive();

  async function fetchResourceById() {
    try {
      setLoading(true);

      if (!id) {
        toast.error("ID do colaborador não fornecido!");
        navigate("/*");
        return;
      }

      const response = await getResourceById(id);

      if (!response.result) {
        toast.error("Colaborador não encontrado!");
        navigate("/*");
        return;
      }

      setResource(includeCustomFieldsfromApi(response.result));
    } catch (error) {
      console.log(error);
      toast.error("Erro ao carregar o Colaborador!");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchResourceById();
  }, [id, openModalAvailability]);

  return (
    <>
      {loading ? (
        <CircularProgress
          size={100}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      ) : (
        <>
          <Resource
            pageType="update"
            resourceData={resource}
            setOpenModalAvailability={setOpenModalAvailability}
            isSyncActive={isSyncActive}
          />
        </>
      )}
    </>
  );
};
